import {data} from "jquery";
import {useGetCatgeory} from "../../../hooks/useCategory";
import ImageComponent from "../../components/shared/ImageComponent";
import {baseImageUrl} from "../../../services/AxiosInstance";
import NoImage from "../../../images/NoImage.jpg";
import {Children} from "react";
import CustomSelectDropdown from "./selectDropDown";

const SelectSubCategory = ({
  selectedCategory,
  selectedSubCategory,
  setSelectedSubCategory,
  children,
}) => {
  const handleSelect = (e) => {
    const subCategory = e;

    if (subCategory) {
      setSelectedSubCategory((prev) => {
        let set = new Set([...prev, subCategory]);
        return Array.from(set.values());
      });
    }
  };
  return (
    // <section>
    //   <h4 className="font-bold text-[22px] text-[#19295C] ">
    //     Choisir une ou plusieurs sous-catégories
    //   </h4>
    //   <div className="flex flex-col w-full p-5 gap-10">
    //     <div className="flex w-full ">
    <div className="form-group w-full col-span-2 lg:col-span-1">
      <label className="required-field-label text-base font-medium !leading-6 text-[#7E7E7E]">
        Sous-Catégorie
      </label>

      <CustomSelectDropdown
        sectorCategories={selectedCategory?.SubCategories}
        selectedCategory={selectedSubCategory}
        setSelectedCategory={handleSelect}
        disabled={!!selectedCategory ? false : true}
        IsSubCategory={true}
      />
      {/* 
      <select
        className="form-control mb-3"
        disabled={!!selectedCategory ? false : true}
        onChange={handleSelect}
      >
        <option value="" disabled selected hidden>
          Choisir vos sous-catégories
        </option>
        {selectedCategory?.SubCategories?.map((subCategory) => (
          <option value={subCategory.id}>{subCategory.title}</option>
        ))}
      </select> */}
      <div className="flex justify-start items-center gap-2 mt-1">
        {!!selectedSubCategory?.length &&
          selectedSubCategory?.map((ele) => (
            <div className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-bold text-sm  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] ">
              {ele.title}{" "}
              <i
                className="fi fi-rr-cross-small flex justify-center items-center cursor-pointer"
                onClick={() => {
                  setSelectedSubCategory((prev) => [
                    ...prev.filter((el) => el.id !== ele.id),
                  ]);
                }}
              ></i>
            </div>
          ))}
      </div>
    </div>
    //     </div>
    //     {children}
    //   </div>
    // </section>
  );
};
export default SelectSubCategory;
